import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '增量分支',
    type: 'ISRF_BRANCH',
}
